import { render, staticRenderFns } from "./NgoHeader.vue?vue&type=template&id=5fac97ba&"
import script from "./NgoHeader.vue?vue&type=script&lang=js&"
export * from "./NgoHeader.vue?vue&type=script&lang=js&"
import style0 from "./NgoHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports